import axios from "axios";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import Slider from "react-slick";
import swal from "sweetalert";
import Jainamaj from "../../../../Assets/Images/ball.jpg";
import { default as Habibi } from "../../../../Assets/Images/bat.jpg";
import Topi from "../../../../Assets/Images/greens.jpg";
import Greetings from "../../../../Assets/Images/Greetings.png";
import LiveChat from "../../../../Assets/Images/LiveChat.png";
import QAMeet from "../../../../Assets/Images/MeetQA.png";
import QA from "../../../../Assets/Images/QA.png";
import "./StarProfileRightContent.css";
import Main from "../../../../Assets/Images/a1.jpg";
import Main1 from "../../../../Assets/Images/a2.jpg";
import Audi from "../../../../Assets/Images/a3.jpg";
import { serverInfo } from "../../../../App";
import ReactPlayer from "react-player";

const StarProfileRightContent = ({
  star_id,
  openMessenger,
  setOpenMessenger,
}) => {


  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const history = useHistory();

  const [loading, setloading] = useState(true);
  // const [openMessenger, setOpenMessenger] = React.useState(false);

  const [getSouviner, setGetSouviner] = useState({});
  const [learningPosts, setLearningPosts] = useState([]);
  const [auditionPosts, setAuditionPosts] = useState([]);
  const [marketplace, setMarketplace] = useState({});
  const [auction, setAuction] = useState({});

  let greetingsCheck = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/user/greetings_star_status/" + star_id).then((res) => {
        if (res.data.status === 200) {
          history.push(`/starprofile/${star_id}/greeting`);
        } else {
          swal("error", "Data base Error", "error");
        }
      });
    });
  };
  const { url } = useRouteMatch();

  var settings = {
    dots: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    axios.get("/api/user/souviner/view/" + star_id).then((res) => {
      if (res.data.status === 200) {
        setGetSouviner(res.data?.getSouviner);
        setloading(false);
      }
    });


    axios.get("/api/user/marketplace/all/" + star_id).then((res) => {
      if (res.data.status === 200) {
        setMarketplace(res.data?.starMarketplace[0]);
      }
    });
    
    axios.get("/api/user/getStarAuction/" + star_id).then((res) => {
      if (res.data.status === 200) {
        setAuction(res.data?.product[0]);
      }
    });

    axios.get(`api/user/getStarPost/${star_id}/learning`).then((res) => {
      if (res.data.status === 200) {
          setLearningPosts(res.data.posts);
      }
    });
    axios.get(`api/user/getStarPost/${star_id}/audition`).then((res) => {
      if (res.data.status === 200) {
          setAuditionPosts(res.data.posts);
      }
    });
  }, []);


  const handleService = () => {
    axios.get("/api/user/souviner/view/" + star_id).then((res) => {
      
      if (res.data.status === 200) {
        history.push(`/starprofile/${star_id}/souvenir`);
      } else {
        // swal("error", "No!", "error");
        swal("Unavailable now", "Souvenir Not Available Now", "warning");
      }
    });
  };

  return (
    <>
      <div className="star-right-sticky TabStar">
        <div className=" left-star-profile-sidebar">
          <div className="card mx-auto my-4 left-card-star left-star-card ">
            <div className="row ">
              <div className="col-md-6">
                <div className="card  bg-dark border-0 mx-3 my-2">
                  <img src={Greetings} alt="" />
                  <button className="BTbtn" onClick={greetingsCheck}>
                    Greetings
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card  bg-dark  border-0  mx-3 my-2">
                  <img src={LiveChat} alt="" />
                  <Link to={`/starprofile/${star_id}/livechat`}>
                    {" "}
                    <button className="BTbtn">Live Chat</button>
                  </Link>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card  bg-dark border-0 mx-3 my-2">
                  <img src={QA} alt="" />
                  <Link to={`/starprofile/${star_id}/qna`}>
                    <button className="BTbtn">Q & A</button>
                  </Link>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card  bg-dark  border-0 mx-3 my-2">
                  <img src={QAMeet} alt="" />
                  <Link to={`/starprofile/${star_id}/meetup`}>
                    <button className="BTbtn">Meetup</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {auditionPosts.length > 0 ? (
            <div className="card mx-auto my-4 left-card-star left-star-card">
              <div className="card-body">
                <h6 className="card-title text-warning">
                  Audition Announcement
                </h6>

                <div className="star-content">
                  <Slider {...settings}>
                    {auditionPosts.map((post) => (
                      <div className="p-1">
                        <img
                          src={imageCdnUrl + post.learning_session?.banner}
                          alt=""
                          className="img-fluid souviner-product-img"
                        />
                      </div>
                    ))}
                  </Slider>
                  <Link to={`/starprofile/${star_id}/audition`}>
                    <button
                      type=""
                      className="btn w-100 btn-warning fw-bold btnBro"
                    >
                      See All Audition Announcement{" "}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ) : null}

          {learningPosts.length > 0 ? (
            <div className="card mx-auto my-4 left-card-star left-star-card">
              <div className="card-body">
                <h6 className="card-title text-warning">Learning Session </h6>
                
                <div className="star-content">
                  <Slider {...settings}>
                    {learningPosts.map((post) => (
                        <>
                        {post.learning_session?.banner ? <img
                          src={post.learning_session ? imageCdnUrl + post.learning_session?.banner : Topi}
                          alt=""
                          className="img-fluid star-Show show-update m-2"
                        />:
                        <ReactPlayer  url={videoCdnUrl + post.learning_session?.video}
                    controls={true}
                    playing={false}
                    volume={1}
                    height={100}
                    className="img-fluid star-Show show-update m-2" />
                      }
                        
                      
                        </>
                    ))}
                  </Slider>
                  <Link to={`/starprofile/${star_id}/learning`}>
                    <button
                      type=""
                      className="btn w-100 btn-warning fw-bold btnBro"
                    >
                      See All Learning Session{" "}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="card mx-auto my-4 left-card-star left-star-card">
            <div className="card-body">
              <h6 className="card-title text-warning">Star Showcase</h6>

              <div className="star-content">
                <div className="d-flex">
                  <div className="col-md-4">
                    <div className="">
                    <img src={marketplace?.image  ? imageCdnUrl + marketplace?.image :Topi}  className="img-fluid star-Show" alt="" />
                      <Link to={`/starprofile/${star_id}/star-marketplace`}>
                        <button className="w-100 enroll-btn mt-1 btn-warning border-0 rounded-3 fw-bold">
                          <small>Marketplace</small>
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-4 mx-1">
                    <div className="">

                    <img src={auction?.product_image ? imageCdnUrl + auction?.product_image :Topi}  className="img-fluid star-Show" alt="" />
                   
                      <Link to={`/starprofile/${star_id}/star-auction`}>
                        <button className="w-100 enroll-btn mt-1 btn-warning border-0 rounded-3 fw-bold">
                          <small>Auction</small>
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-4 ">
                    <div className="">
                    <img src={getSouviner?.banner ? imageCdnUrl + getSouviner?.banner :Topi}  className="img-fluid star-Show" alt="" />
                      <button
                        onClick={handleService}
                        className="w-100 enroll-btn mt-1 btn-warning border-0 rounded-3 fw-bold"
                      >
                        <small>Souvenir</small>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="text-center "></div>
              </div>
            </div>
          </div>
          <div className="dropDownParent">
            <div className="dropdown"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarProfileRightContent;
